<template>
    <div id="app">
      <!-- <nav>
        <router-link to="/">餐馆介绍</router-link> |
        <router-link to="/full-screen-menu">菜单</router-link> |
        <router-link to="/order">在线下单</router-link> |
        <router-link to="/reserve">预订座位</router-link>
      </nav> -->
      <router-view />
    </div>
  </template>
  <script>
  export default {
    name: 'App',
  };
  </script>
  
  <!-- <style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  
  nav {
    padding: 30px;
  }
  
  nav a {
    font-weight: bold;
    color: #2c3e50;
    text-decoration: none;
    padding: 10px;
    border-radius: 4px;
  }
  
  nav a.router-link-exact-active {
    background-color: #42b983;
    color: white;
  }
  
  /* 移动端适配 */
  @media (max-width: 768px) {
    nav {
      padding: 10px;
      display: flex;
      flex-direction: column;
    }
    nav a {
      margin-bottom: 5px;
    }
  }
  </style> -->
  <style>
/* 全局样式，例如字体、margin/padding 重置等 */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0; /* 去掉默认的 body margin */
  box-sizing: border-box; /* 统一盒模型 */
}
*, *:before, *:after {
  box-sizing: inherit;
}
</style>